import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { EmployeeAddComponent } from './component/employe-add/employe-add.component';
import { EmployeeFormComponent } from './component/employee-form/employee-form.component';
import { EmployeeManageComponent } from './component/employee-manage/employee-manage.component';
import { EmployeeSelectComponent } from './component/employee-select/employee-select.component';
import { EmployeeMultiselectComponent } from './component/employee-multiselect/employee-multiselect.component';
import { OpenEmployeeManageComponent } from './component/open-employee-manage/open-employee-manage.component';
import { EmployeeCompanyAddComponent } from './component/employee-company-add/employee-company-add.component';
import { EmployeeCompanyFormComponent } from './component/employee-company-form/employee-company-form.component';
import { EmployeeCompanyManageComponent } from './component/employee-company-manage/employee-company-manage.component';
import { EmployeeCompanyAssociatedEmployeesComponent } from './component/employee-company-associated-employees/employee-company-associated-employees.component';
import { EmployeeSelectDialogComponent } from './component/employee-select-dialog/employee-select-dialog.component';



const sharedComponents = 
[
  EmployeeAddComponent,
  EmployeeManageComponent,
  EmployeeSelectComponent,
  EmployeeFormComponent,
  EmployeeCompanyFormComponent,
  EmployeeMultiselectComponent,
  OpenEmployeeManageComponent,
  EmployeeCompanyAddComponent,
  EmployeeCompanyManageComponent,
  EmployeeCompanyAssociatedEmployeesComponent,
  EmployeeSelectDialogComponent
]

@NgModule({
  declarations: [
    sharedComponents
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    sharedComponents
  ]
})

export class EmployeesModule { }
